import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { CheckCircle2, XCircle, Loader } from 'lucide-react';
import { fmt } from '../utils/helpers';
import api from '../services/api';

export default function VerifyReceipt() {
  const [params] = useSearchParams();
  const r = params.get('r');
  const s = params.get('s');

  const [status, setStatus]   = useState('loading'); // loading | valid | invalid | error
  const [data,   setData]     = useState(null);

  useEffect(() => {
    if (!r || !s) { setStatus('invalid'); return; }
    api.get('/payments/verify', { params: { r, s } })
      .then(res => { setData(res.data); setStatus('valid'); })
      .catch(err => {
        if (err.response?.status === 400 || err.response?.status === 404) setStatus('invalid');
        else setStatus('error');
      });
  }, [r, s]);

  return (
    <div style={{ minHeight: '100vh', background: 'var(--surface-1, #f5f5f7)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ background: '#fff', borderRadius: 16, padding: 32, maxWidth: 420, width: '100%', boxShadow: '0 4px 24px rgba(0,0,0,.08)', fontFamily: 'system-ui, sans-serif' }}>

        {/* Brand */}
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{ fontSize: 22, fontWeight: 800, color: '#4f46e5', letterSpacing: '-.01em' }}>PropManager</div>
          <div style={{ fontSize: 13, fontWeight: 700, color: '#1e1e2e', marginTop: 2, letterSpacing: '.06em' }}>MERCURY</div>
          <div style={{ fontSize: 11, color: '#888', marginTop: 6, textTransform: 'uppercase', letterSpacing: '.08em' }}>Verificación de recibo</div>
        </div>

        {/* Loading */}
        {status === 'loading' && (
          <div style={{ textAlign: 'center', padding: '24px 0', color: '#888' }}>
            <Loader size={32} style={{ animation: 'spin 1s linear infinite', margin: '0 auto 12px' }}/>
            <div style={{ fontSize: 14 }}>Verificando autenticidad…</div>
          </div>
        )}

        {/* Valid */}
        {status === 'valid' && data && (
          <>
            <div style={{ textAlign: 'center', marginBottom: 20 }}>
              <CheckCircle2 size={48} color="#10b981" style={{ margin: '0 auto 10px' }}/>
              <div style={{ fontSize: 18, fontWeight: 700, color: '#10b981' }}>Recibo Auténtico</div>
              <div style={{ fontSize: 13, color: '#666', marginTop: 4 }}>Este documento fue emitido por PropManager Mercury y no ha sido alterado.</div>
            </div>
            <div style={{ background: '#f9fafb', borderRadius: 10, padding: 16, border: '1px solid #e5e7eb' }}>
              {[
                ['Recibo #',    data.receiptNo],
                ['Fecha',       fmt.date(data.paidDate)],
                ['Inquilino',   data.tenant],
                ['Unidad',      data.unit ? `# ${data.unit}` : '—'],
                ['Monto',       data.amount != null ? `$${Number(data.amount).toLocaleString('en-US', { minimumFractionDigits: 2 })}` : '—'],
              ].map(([k, v]) => (
                <div key={k} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, padding: '7px 0', borderBottom: '1px solid #f0f0f0' }}>
                  <span style={{ color: '#888' }}>{k}</span>
                  <span style={{ fontWeight: 700 }}>{v || '—'}</span>
                </div>
              ))}
            </div>
            <div style={{ marginTop: 16, fontSize: 11, color: '#bbb', textAlign: 'center', fontFamily: 'monospace', wordBreak: 'break-all' }}>SIG: {s}</div>
          </>
        )}

        {/* Invalid / tampered */}
        {status === 'invalid' && (
          <div style={{ textAlign: 'center', padding: '8px 0' }}>
            <XCircle size={48} color="#ef4444" style={{ margin: '0 auto 10px' }}/>
            <div style={{ fontSize: 18, fontWeight: 700, color: '#ef4444' }}>No se pudo verificar</div>
            <div style={{ fontSize: 13, color: '#666', marginTop: 8 }}>
              Este recibo no existe en nuestros registros o los datos pueden haber sido alterados.
              Contacte a Mercury para más información.
            </div>
          </div>
        )}

        {/* Network error */}
        {status === 'error' && (
          <div style={{ textAlign: 'center', padding: '8px 0', color: '#888' }}>
            <div style={{ fontSize: 14 }}>No se pudo conectar al servidor. Intente de nuevo.</div>
          </div>
        )}

        <div style={{ marginTop: 24, textAlign: 'center', fontSize: 11, color: '#ccc' }}>
          propmanager.mercurysoftwaresolutions.com
        </div>
      </div>

      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
